<mat-toolbar color="primary">
    <mat-toolbar-row fxLayout="row">
        <span> Change Password </span>
        <span class="spacer"></span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="mat-typography">
    <form [formGroup]="changePasswordFormGroup">
        <div fxFlex fxLayout="column">
            <div fxLayout="row wrap">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Old Password</mat-label>
                    <input placeholder="Old Password" matInput [type]="hideOldPassword ? 'password' : 'text'"
                        formControlName="oldPassword">
                    <button mat-icon-button matSuffix (click)="hideOldPassword = !hideOldPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideOldPassword">
                        <mat-icon>{{hideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-hint class="color-red"
                        *ngIf="changePasswordFormGroup.get('oldPassword').touched && changePasswordFormGroup.get('oldPassword').errors?.required">
                        *Old Password required</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div fxFlex fxLayout="column">
            <div fxLayout="row wrap">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>New Password</mat-label>
                    <input placeholder="New Password" matInput [type]="hideNewPassword ? 'password' : 'text'"
                        formControlName="newPassword">
                    <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword">
                        <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-hint class="color-red"
                        *ngIf="changePasswordFormGroup.get('newPassword').touched && changePasswordFormGroup.get('newPassword').errors?.required">
                        *New Password required</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div fxFlex fxLayout="column">
            <div fxLayout="row wrap">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Confirm Password</mat-label>
                    <input placeholder="Confirm Password" matInput [type]="hideConfirmPassword ? 'password' : 'text'"
                        formControlName="confirmPassword">
                    <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
                        <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-hint class="color-red"
                        *ngIf="((changePasswordFormGroup.get('newPassword').touched || changePasswordFormGroup.get('newPassword')?.dirty) && (changePasswordFormGroup.get('confirmPassword').touched || changePasswordFormGroup.get('confirmPassword')?.dirty)) && changePasswordFormGroup.get('newPassword').value !== changePasswordFormGroup.get('confirmPassword').value">
                        Password mismatched</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button type="button" mat-button mat-dialog-close>Cancel</button>
    <button type="submit" (click)="handleChangePasswordSubmit()"
        [disabled]="changePasswordFormGroup.invalid || changePasswordFormGroup.get('newPassword').value !== changePasswordFormGroup.get('confirmPassword').value"
        mat-raised-button color="primary">Change Password</button>
</mat-dialog-actions>